<template>
  <div class="flex-shrink-0">
    <FlashMessage
      v-for="(flashMessage, index) in flashMessages"
      :flash-message="flashMessage"
      :index="index"
      :key="index"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

import FlashMessage from "@/components/FlashMessage.vue";

export default {
  name: "FlashMessages",
  components: {
    FlashMessage,
  },
  computed: {
    ...mapState(["flashMessages"]),
  },
};
</script>
